import { Link } from "react-router-dom";

const SocialsNav = () => {
  return (
    <div className="socials-nav inverseNav">
      <Link to="https://github.com/avi-spc" target="_blank">
        <svg
          width="26"
          height="26"
          viewBox="0 0 50 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.9987 0C11.1929 0 0 11.1936 0 25.0013C0 36.0468 7.16154 45.4173 17.0968 48.7212C18.3481 48.9526 18.8032 48.1827 18.8032 47.518C18.8032 46.9256 18.7814 45.3545 18.7705 43.266C11.816 44.7782 10.3487 39.9141 10.3487 39.9141C9.21154 37.0263 7.57244 36.2583 7.57244 36.2583C5.30256 34.7083 7.74487 34.7385 7.74487 34.7385C10.2538 34.916 11.5744 37.3141 11.5744 37.3141C13.8038 41.1346 17.4263 40.0288 18.85 39.3929C19.0763 37.7744 19.7237 36.675 20.4372 36.0487C14.8865 35.4179 9.05064 33.2731 9.05064 23.6936C9.05064 20.9635 10.0244 18.7314 11.6231 16.9833C11.3673 16.3538 10.5077 13.8122 11.8686 10.3686C11.8686 10.3686 13.9673 9.69679 18.7442 12.9333C20.7372 12.3763 22.8763 12.0981 25.0026 12.0897C27.1256 12.0987 29.2654 12.3763 31.2609 12.9333C36.0346 9.69679 38.1301 10.3686 38.1301 10.3686C39.4942 13.8122 38.6353 16.3538 38.3788 16.9833C39.9814 18.7314 40.9481 20.9635 40.9481 23.6936C40.9481 33.2955 35.1038 35.4109 29.5346 36.0276C30.4308 36.8 31.2308 38.3288 31.2308 40.6615C31.2308 44.0019 31.2006 46.6974 31.2006 47.5173C31.2006 48.1872 31.65 48.966 32.9192 48.7179C42.8436 45.4071 50 36.0436 50 25.0013C50 11.1936 38.8071 0 24.9987 0Z"
            fill="#B7AB98"
          />
        </svg>
      </Link>
      <Link to="https://www.linkedin.com/in/avi-spc/" target="_blank">
        <svg
          width="26"
          height="26"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 0C10.746 0 0 10.746 0 24C0 37.254 10.746 48 24 48C37.254 48 48 37.254 48 24C48 10.746 37.254 0 24 0ZM14.992 10.806C16.676 10.806 17.798 11.928 17.798 13.424C17.798 14.92 16.676 16.042 14.806 16.042C13.122 16.044 12 14.92 12 13.424C12 11.928 13.122 10.806 14.992 10.806ZM18 34H12V18H18V34ZM38 34H32.352V25.256C32.352 22.838 30.846 22.28 30.282 22.28C29.718 22.28 27.834 22.652 27.834 25.256C27.834 25.628 27.834 34 27.834 34H22V18H27.836V20.232C28.588 18.93 30.094 18 32.918 18C35.742 18 38 20.232 38 25.256V34Z"
            fill="#B7AB98"
          />
        </svg>
      </Link>
      <Link to="https://www.instagram.com/creativekonami/" target="_blank">
        <svg
          width="26"
          height="26"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.486 0 0 4.486 0 10V26C0 31.514 4.486 36 10 36H26C31.514 36 36 31.514 36 26V10C36 4.486 31.514 0 26 0H10ZM10 4H26C29.308 4 32 6.692 32 10V26C32 29.308 29.308 32 26 32H10C6.692 32 4 29.308 4 26V10C4 6.692 6.692 4 10 4ZM28 6C27.4696 6 26.9609 6.21071 26.5858 6.58579C26.2107 6.96086 26 7.46957 26 8C26 8.53043 26.2107 9.03914 26.5858 9.41421C26.9609 9.78929 27.4696 10 28 10C28.5304 10 29.0391 9.78929 29.4142 9.41421C29.7893 9.03914 30 8.53043 30 8C30 7.46957 29.7893 6.96086 29.4142 6.58579C29.0391 6.21071 28.5304 6 28 6ZM18 8C12.486 8 8 12.486 8 18C8 23.514 12.486 28 18 28C23.514 28 28 23.514 28 18C28 12.486 23.514 8 18 8ZM18 12C21.308 12 24 14.692 24 18C24 21.308 21.308 24 18 24C14.692 24 12 21.308 12 18C12 14.692 14.692 12 18 12Z"
            fill="#B7AB98"
          />
        </svg>
      </Link>
      <svg
        width="26"
        height="26"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32ZM4.664 12.054C5.40658 9.92743 6.73157 8.05221 8.488 6.642C9.024 7.46 9.948 8 11 8C11.7956 8 12.5587 8.31607 13.1213 8.87868C13.6839 9.44129 14 10.2044 14 11V12C14 13.0609 14.4214 14.0783 15.1716 14.8284C15.9217 15.5786 16.9391 16 18 16C19.0609 16 20.0783 15.5786 20.8284 14.8284C21.5786 14.0783 22 13.0609 22 12C21.9997 11.1048 22.2996 10.2355 22.8519 9.53094C23.4041 8.82642 24.1767 8.32749 25.046 8.114C26.9546 10.2973 28.0045 13.1 28 16C28 16.68 27.944 17.35 27.834 18H26C24.9391 18 23.9217 18.4214 23.1716 19.1716C22.4214 19.9217 22 20.9391 22 22V26.394C20.1766 27.449 18.1066 28.0031 16 28V24C16 22.9391 15.5786 21.9217 14.8284 21.1716C14.0783 20.4214 13.0609 20 12 20C10.9391 20 9.92172 19.5786 9.17157 18.8284C8.42143 18.0783 8 17.0609 8 16C8.00035 15.054 7.66541 14.1385 7.05466 13.4161C6.44391 12.6936 5.59688 12.211 4.664 12.054Z"
          fill="#B7AB98"
        />
      </svg>
    </div>
  );
};

export default SocialsNav;
